class GridToggle {
  constructor() {
    this.toggleButtons = document.querySelectorAll('.grid-toggle-btn');
    this.productGrid = this.productGrid;
    this.storageKey = 'collection-grid-columns';
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
    this.currentColumns = null;

    this.init();
  }

  init() {
    if (document.body.dataset.enablePlpEnhancements !== 'true') return;
    if (!this.toggleButtons.length || !this.productGrid) {
      return;
    }

    // Load saved preference
    this.loadPreference();

    // Add click handlers
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => this.handleToggle(e));
    });

    this.desktopQuery.addEventListener('change', () => {
      if (this.currentColumns != null) this.applyColumns(this.currentColumns);
    });
  }

  get productGrid() {
    if (!this._productGrid || !this._productGrid.isConnected) {
      this._productGrid = document.querySelector('#main-collection-product-grid');
    }
    return this._productGrid;
  }

  set productGrid(value) {
    this._productGrid = value;
  }

  handleToggle(event) {
    const button = event.currentTarget;
    const columns = button.getAttribute('data-columns');

    // Update active state
    this.toggleButtons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Update grid
    this.applyColumns(columns);

    // Save preference
    this.savePreference(columns);
  }

  applyColumns(columns) {
    this.currentColumns = columns;
    if (this.desktopQuery.matches) {
      this.productGrid.classList.remove('single-column');
    } else if (columns === '1') {
      this.productGrid.classList.add('single-column');
    } else {
      this.productGrid.classList.remove('single-column');
    }
  }

  savePreference(columns) {
    try {
      localStorage.setItem(this.storageKey, columns);
    } catch (e) {
      // localStorage not available
    }
  }

  loadPreference() {
    try {
      const savedColumns = localStorage.getItem(this.storageKey);
      if (savedColumns) {
        // Update active button
        this.toggleButtons.forEach(btn => {
          btn.classList.toggle('active', btn.getAttribute('data-columns') === savedColumns);
        });
        // Apply layout
        this.applyColumns(savedColumns);
      }
    } catch (e) {
      // localStorage not available
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new GridToggle());
} else {
  new GridToggle();
}
